// standard top columns
export const DOB: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-dob',
  label: 'DOB',
  property: 'date_of_birth',
  transformer: 'friendly_date',
  dataSize: 'ms'
};

export const DOB_AGE_BY_DOS: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-dob',
  label: 'DOB',
  property: 'date_of_birth',
  transformer: 'dob_age_by_dos',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l'
};


export const GENDER: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-gender',
  label: 'Gender',
  property: 'patient_gender',
  dataSize: 'ms'
};

export const MRN: CMxCommonApp.PatientDataDefinition = {
  key: 'patient-mrn',
  label: 'MRN',
  property: 'patient_identifier',
  transformer: 'mrn',
  dataSize: 'ms'
};

// standard mid columns
export const ACCESSION: CMxCommonApp.PatientDataDefinition = {
  key: 'accession',
  label: 'Accession',
  property: 'primary_clinical_identifier',
  transformer: 'identifier',
  dataSize: 'ms'
};

export const EXAM_CODE: CMxCommonApp.PatientDataDefinition = {
  key: 'exam_code',
  label: 'Exam Code',
  property: 'exam_code',
  dataSize: 'ms'
};

export const PRIMARY_INSURANCE: CMxCommonApp.PatientDataDefinition = {
  key: 'primary_insurance',
  label: 'Primary Insurance',
  property: 'primary_insurance',
  dataSize: 'l'
};

export const REASON_FOR_VISIT: CMxCommonApp.PatientDataDefinition = {
  key: 'reason_for_visit',
  label: 'Reason for Visit',
  property: 'reason_for_visit',
  dataSize: 'm'
};

export const DOS: CMxCommonApp.PatientDataDefinition = {
  key: 'date_of_service',
  label: 'Date of Service',
  property: 'date_of_service',
  dataSize: 'ms',
  transformer: 'date_of_service',
  fieldType: 'date'
};

export const EXAM_DESCRIPTION: CMxCommonApp.PatientDataDefinition = {
  key: 'exam_description',
  label: 'Exam Description',
  property: 'exam_description',
  dataSize: 'l'
};

// standard bottom columns

export const ORDERING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'ordering_provider_name',
  label: 'Ordering Provider',
  property: 'ordering_provider_name',
  dataSize: 'ms'
};

export const ORDERING_PROVIDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'ordering_provider_number',
  label: 'Ordering Provider ID',
  property: 'ordering_provider_number',
  transformer: 'numerical',
  dataSize: 'ms'
};

export const ORDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'order_number',
  label: 'Order ID',
  property: 'order_number',
  transformer: 'numerical',
  dataSize: 'ms'
};

export const PLACE_OF_SERVICE: CMxCommonApp.PatientDataDefinition = {
  key: 'place_of_service',
  label: 'Place of Service',
  property: 'place_of_service',
  dataSize: 'ms'
};

export const TENANT_NAME: CMxCommonApp.PatientDataDefinition = {
  key: 'tenant_name',
  label: 'Tenant Name',
  property: 'tenant_name',
  dataSize: 'm'
};

export const BILLING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'billing_provider_name',
  label: 'Billing Provider',
  property: 'billing_provider_name',
  dataSize: 'ms'
};

export const BILLING_PROVIDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'billing_provider_number',
  label: 'Billing Provider ID',
  property: 'billing_provider_number',
  transformer: 'numerical',
  dataSize: 'ms'
};

export const PROCEDURE_TYPE: CMxCommonApp.PatientDataDefinition = {
  key: 'procedure_type',
  label: 'Procedure Type',
  property: 'procedure_type',
  dataSize: 'ms'
};

export const PROCEDURE_TYPE_CATEGORY: CMxCommonApp.PatientDataDefinition = {
  key: 'procedure_type_category',
  label: 'Procedure Type',
  property: 'procedure_type_category',
  dataSize: 'ms'
};

export const VISIT_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'visit_number',
  label: 'Visit Number',
  transformer: 'numerical',
  property: 'visit_number',
  dataSize: 'ms'
};

export const CASE_ID: CMxCommonApp.PatientDataDefinition = {
  key: 'case_id',
  label: 'CMX Case ID',
  property: 'case_id',
  dataSize: 'ms'
};

// PATH SPECIFIC

export const SPECIMEN_SOURCES: CMxCommonApp.PatientDataDefinition = {
  key: 'specimen_sources',
  label: 'Primary Specimen Source',
  transformer: 'specimen_sources',
  property: 'specimen_sources',
  dataSize: 'm'
};

export const GROUPER: CMxCommonApp.PatientDataDefinition = {
  key: 'grouper',
  label: 'Specimen category',
  property: 'grouper',
  dataSize: 'ms'
};

export const HAR: CMxCommonApp.PatientDataDefinition = {
  key: 'hospital_account_record',
  label: 'Hospital Account Record',
  property: 'hospital_account_record',
  dataSize: 'ms'
};

export const ENCOUNTER_NUMBER = {
  ...HAR,
  label: 'Encounter'
};

export const PROCESS_ID: CMxCommonApp.PatientDataDefinition = {
  key: 'case_json_id',
  label: 'CMX Process ID',
  property: 'case_json_id',
  dataSize: 'ms'
};

export const CASE_TYPE: CMxCommonApp.PatientDataDefinition = {
  key: 'case_type',
  label: 'Case Type',
  property: 'case_type',
  dataSize: 'ms'
};

// surg columns

export const SCHEDULED_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'primary_provider_name',
  label: 'Scheduled Provider',
  property: 'primary_provider_name',
  dataSize: 'ms'
};

export const SCHEDULED_PROVIDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'ordering_provider_number',
  label: 'Ordering Provider ID',
  property: 'ordering_provider_number',
  transformer: 'numerical',
  dataSize: 'ms'
};

export const BILLING_AREA: CMxCommonApp.PatientDataDefinition = {
  key: 'billing_area',
  label: 'Billing Area',
  property: 'billing_area',
  dataSize: 'ms'
};

export const DEPARTMENT: CMxCommonApp.PatientDataDefinition = {
  key: 'scheduling_department',
  label: 'Department',
  property: 'scheduling_department',
  dataSize: 'ms'
};

export const SPECIALTY: CMxCommonApp.PatientDataDefinition = {
  key: 'specialty',
  label: 'Specialty',
  property: 'specialty',
  dataSize: 'ms'
};

// Automate/IPC columns

export const FINANCIAL_STATUS_CLASS: CMxCommonApp.PatientDataDefinition = {
  key: 'financial_status_class',
  label: 'Financial Status Class',
  property: 'financial_status_class',
  dataSize: 'ms',
  fieldType: 'dictionary'
};

export const FACILITY: CMxCommonApp.PatientDataDefinition = {
  key: 'billing_location',
  label: 'Facility',
  property: 'billing_location',
  dataSize: 'ms',
  fieldType: 'dictionary'
};

export const PATIENT_CLASS: CMxCommonApp.PatientDataDefinition = {
  key: 'patient_class',
  label: 'Patient Class',
  property: 'patient_class',
  dataSize: 'ms'
};

export const PATIENT_TYPE: CMxCommonApp.PatientDataDefinition = {
  key: 'patient_type',
  label: 'Patient Type',
  property: 'patient_type',
  dataSize: 'ms',
  fieldType: 'dictionary'
};

export const AUTHENTICATOR_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'assigned_document_auth_name',
  label: 'Authenticator',
  property: 'assigned_document_auth_name',
  dataSize: 'ms',
  hasLink: true,
  additionalInfo: [
    {
      property: 'assigned_document_auth_number',
      label: 'providerNumber'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'assigned_document_auth_name',
      label: 'providerName'
    }
  ]
};

export const ADMITTING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'admitting_provider_name',
  label: 'Admitting Provider',
  property: 'admitting_provider_name',
  dataSize: 'ms',
  dataSizeHorizontalView: 'l',
  hasLink: true,
  additionalInfo: [
    {
      property: 'admitting_provider',
      label: 'providerNumber',
      transformer: 'numerical'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'admitting_provider_name',
      label: 'providerName'
    }
  ]
};

export const AUTHENTICATOR_PROVIDER_NUMBER: CMxCommonApp.PatientDataDefinition = {
  key: 'assigned_document_auth_number',
  label: 'Authenticator Provider ID',
  property: 'assigned_document_auth_number',
  dataSize: 'l'
};

export const SERVICE_LINE: CMxCommonApp.PatientDataDefinition = {
  key: 'service_line',
  label: 'Service Line',
  property: 'service_line',
  transformer: 'service_line',
  dataSize: 'ms'
};

export const ADMISSION_DATE: CMxCommonApp.PatientDataDefinition = {
  key: 'admission_datetime',
  label: 'Admission Date',
  property: 'admission_datetime',
  dataSize: 'ms',
  transformer: 'date_of_service',
  fieldType: 'date'
};

export const DISCHARGE_DATE: CMxCommonApp.PatientDataDefinition = {
  key: 'discharge_datetime',
  label: 'Discharge Date',
  property: 'discharge_datetime',
  dataSize: 'ms',
  transformer: 'date_of_service',
  fieldType: 'date'
};

export const EM_CATEGORY: CMxCommonApp.PatientDataDefinition = {
  key: 'em_category',
  label: 'Case E/M Category',
  property: 'em_category',
  dataSize: 'ms',
  fieldType: 'dictionary'
};

export const SERVICE_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'service_provider_name',
  label: 'Authoring Provider',
  property: 'primary_activity_provider_name',
  dataSize: 'ms'
};

export const AUTHORING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'authoring_provider_name',
  label: 'Authoring Provider',
  property: 'primary_activity_provider_name',
  dataSize: 'ms',
  hasLink: true,
  additionalInfo: [
    {
      property: 'primary_activity_provider_number',
      label: 'providerNumber'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'primary_activity_provider_name',
      label: 'providerName'
    }
  ]
};

export const FINAL_SIGNING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'note_final_sign_provider',
  label: 'Final Sign Provider',
  property: 'note_final_sign_provider_name',
  dataSize: 'ms',
  hasLink: true,
  additionalInfo: [
    {
      property: 'note_final_sign_provider_number',
      label: 'providerNumber'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'note_final_sign_provider_name',
      label: 'providerName'
    }
  ]
};

export const NOTE_SPECIALTY: CMxCommonApp.PatientDataDefinition = {
  key: 'note_specialty_designation',
  label: 'NOTE SPECIALTY',
  property: 'note_specialty_designation',
  dataSize: 'ms',
  fieldType: 'dictionary'
};

export const SCHEDULING_ID: CMxCommonApp.PatientDataDefinition = {
  key: 'scheduling_id',
  label: 'SCHEDULING ID',
  property: 'order_filler_number',
  transformer: 'numerical',
  dataSize: 'ms'
};

export const OWNER: CMxCommonApp.PatientDataDefinition = {
  key: 'owner',
  label: 'CODER',
  property: 'owner',
  dataSize: 'ms'
};

export const ASSIGNEE: CMxCommonApp.PatientDataDefinition = {
  key: 'assignee',
  label: 'ASSIGNEE',
  property: 'assignee',
  dataSize: 'ms'
};

export const AGING_DAYS: CMxCommonApp.PatientDataDefinition = {
  key: 'aging_days',
  label: 'AGING DAYS',
  property: 'aging_days',
  dataSize: 'ms'
};

export const CODABLE_DAYS: CMxCommonApp.PatientDataDefinition = {
  key: 'codable_days',
  label: 'CODABLE DAYS',
  property: 'codable_days',
  dataSize: 'ms'
};

export const PATIENT_AGE: CMxCommonApp.PatientDataDefinition = {
  key: 'patient_age',
  label: 'Patient Age',
  property: 'patient_age',
  dataSize: 'ms',
  transformer: 'patient_age_by_dos_dob'
};

export const ATTENDING_PROVIDER: CMxCommonApp.PatientDataDefinition = {
  key: 'attending_provider_name',
  label: 'Attending Provider',
  property: 'attending_provider_name',
  dataSize: 'ms',
  hasLink: true,
  additionalInfo: [
    {
      property: 'attending_provider_number',
      label: 'providerNumber',
      transformer: 'numerical'
    },
    {
      property: 'facility',
      label: 'tenantCode'
    },
    {
      property: 'attending_provider_name',
      label: 'providerName'
    }
  ]
};

// column groups for amplify

export const radAmplifyColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB_AGE_BY_DOS, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [],
  expanded: [
    ACCESSION,
    EXAM_CODE,
    REASON_FOR_VISIT,
    DOS,
    EXAM_DESCRIPTION,
    ORDERING_PROVIDER,
    ORDERING_PROVIDER_NUMBER,
    ORDER_NUMBER,
    PLACE_OF_SERVICE,
    TENANT_NAME,
    BILLING_AREA,
    BILLING_PROVIDER,
    BILLING_PROVIDER_NUMBER,
    PROCEDURE_TYPE,
    VISIT_NUMBER,
    CASE_ID
  ]
};

export const PatientTimelineColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [],
  expanded: []
};

const pathAmplifyColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [...radAmplifyColumns.patient],
  summary: [],
  expanded: [
    ACCESSION,
    CASE_TYPE,
    DOS,
    SPECIMEN_SOURCES,
    ORDERING_PROVIDER,
    ORDERING_PROVIDER_NUMBER,
    ORDER_NUMBER,
    {
      ...PLACE_OF_SERVICE,
      transformer: 'multi_place_of_service'
    },
    TENANT_NAME,
    BILLING_PROVIDER,
    BILLING_PROVIDER_NUMBER,
    GROUPER,
    ENCOUNTER_NUMBER,
    PROCESS_ID,
    CASE_ID
  ]
};

const surgicalAmplifyColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [...radAmplifyColumns.patient],
  summary: [],
  expanded: [
    SERVICE_LINE,
    DOS,
    ENCOUNTER_NUMBER,

    NOTE_SPECIALTY,
    ORDER_NUMBER,
    {
      ...PROCEDURE_TYPE_CATEGORY,
      dataSize: 'ms',
      label: 'Scheduled Description'
    },

    ADMISSION_DATE,
    DISCHARGE_DATE,
    SCHEDULING_ID,

    FINANCIAL_STATUS_CLASS,
    PATIENT_CLASS,
    PATIENT_TYPE,

    ATTENDING_PROVIDER,
    AUTHENTICATOR_PROVIDER,
    AUTHORING_PROVIDER,
    { ...FINAL_SIGNING_PROVIDER, property: 'authentication_person_name' },

    ORDERING_PROVIDER,
    CASE_ID,

    FACILITY,
    DEPARTMENT,
    BILLING_AREA,
    OWNER,
    ASSIGNEE,
    AGING_DAYS,
    CODABLE_DAYS,
    PATIENT_AGE
  ]
};

const ipcAmplifyColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB_AGE_BY_DOS, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [],
  expanded: [
    PATIENT_CLASS,
    PATIENT_TYPE,
    NOTE_SPECIALTY,
    HAR,
    FACILITY,
    DEPARTMENT,
    DOS,
    ADMISSION_DATE,
    DISCHARGE_DATE,

    //SERVICE_PROVIDER,
    AUTHORING_PROVIDER,
    AUTHENTICATOR_PROVIDER,
    FINAL_SIGNING_PROVIDER,
    ADMITTING_PROVIDER,
    ORDERING_PROVIDER,
    FINANCIAL_STATUS_CLASS,
    EM_CATEGORY,
    SERVICE_LINE,
    CASE_ID,
    OWNER,
    ASSIGNEE,
    AGING_DAYS,
    CODABLE_DAYS,
    ATTENDING_PROVIDER,
    SCHEDULING_ID
  ]
};

export const PatientAmplifyEncounterColumns: CMxCommonApp.PatientInformationConfigurationMap = {
  radiology: radAmplifyColumns,
  pathology: pathAmplifyColumns,
  surgery: surgicalAmplifyColumns,
  inpatientprofessionalcoding: ipcAmplifyColumns
};

// column groups for accelerate

export const radDashboardColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [ACCESSION, EXAM_CODE, REASON_FOR_VISIT, DOS, EXAM_DESCRIPTION],
  expanded: [
    ORDERING_PROVIDER,
    ORDERING_PROVIDER_NUMBER,
    ORDER_NUMBER,
    PLACE_OF_SERVICE,
    TENANT_NAME,
    BILLING_AREA,
    BILLING_PROVIDER,
    BILLING_PROVIDER_NUMBER,
    PROCEDURE_TYPE,
    VISIT_NUMBER,
    CASE_ID
  ]
};

const pathDashboardColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [...radDashboardColumns.patient],
  summary: [ACCESSION, CASE_TYPE, DOS, SPECIMEN_SOURCES],
  expanded: [
    ORDERING_PROVIDER,
    ORDERING_PROVIDER_NUMBER,
    ORDER_NUMBER,
    {
      ...PLACE_OF_SERVICE,
      transformer: 'multi_place_of_service'
    },
    TENANT_NAME,
    BILLING_PROVIDER,
    BILLING_PROVIDER_NUMBER,
    GROUPER,
    ENCOUNTER_NUMBER,
    PROCESS_ID,
    CASE_ID
  ]
};

const surgicalDashboardColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [...radDashboardColumns.patient],
  summary: [
    SERVICE_LINE,
    DOS,
    ENCOUNTER_NUMBER,

    NOTE_SPECIALTY,
    ORDER_NUMBER,
    {
      ...PROCEDURE_TYPE_CATEGORY,
      dataSize: 's',
      label: 'Scheduled Description'
    }
  ],
  expanded: [
    ADMISSION_DATE,
    DISCHARGE_DATE,
    SCHEDULING_ID,

    FINANCIAL_STATUS_CLASS,
    PATIENT_CLASS,
    PATIENT_TYPE,

    ATTENDING_PROVIDER,
    AUTHENTICATOR_PROVIDER,
    AUTHORING_PROVIDER,
    { ...FINAL_SIGNING_PROVIDER, property: 'authentication_person_name' },

    ORDERING_PROVIDER,
    CASE_ID,

    FACILITY,
    DEPARTMENT,
    BILLING_AREA,
    PATIENT_AGE
  ]
};

const ipcDashboardColumns: CMxCommonApp.PatientInformationConfiguration = {
  patient: [DOB, GENDER, MRN, PRIMARY_INSURANCE],
  summary: [PATIENT_CLASS, PATIENT_TYPE, NOTE_SPECIALTY],
  expanded: [
    HAR,
    FACILITY,
    DEPARTMENT,
    DOS,
    ADMISSION_DATE,
    DISCHARGE_DATE,

    //SERVICE_PROVIDER,
    AUTHORING_PROVIDER,
    AUTHENTICATOR_PROVIDER,
    FINAL_SIGNING_PROVIDER,
    ADMITTING_PROVIDER,
    ORDERING_PROVIDER,
    FINANCIAL_STATUS_CLASS,
    EM_CATEGORY,
    SERVICE_LINE,
    CASE_ID,
    ATTENDING_PROVIDER,
    SCHEDULING_ID
  ]
};

export const PatientEncounterDashboardColumns: CMxCommonApp.PatientInformationConfigurationMap = {
  radiology: radDashboardColumns,
  pathology: pathDashboardColumns,
  surgery: surgicalDashboardColumns,
  inpatientprofessionalcoding: ipcDashboardColumns,
  patientTimeline: PatientTimelineColumns
};
